import { render, staticRenderFns } from "./DdHaishahyoHimodukeButton.vue?vue&type=template&id=7fb4ab36&scoped=true&"
import script from "./DdHaishahyoHimodukeButton.vue?vue&type=script&lang=js&"
export * from "./DdHaishahyoHimodukeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb4ab36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VTooltip})
